import { render } from "./Authorization.vue?vue&type=template&id=6bc54d81"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import exportComponent from "/var/tmp/gitlab_runner/builds/tK6kkzxJV/0/electronics/garden-alarm-system/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__